import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@zillow/constellation';
import { ColorPropType, SizePropType } from './prop-types.js';
import { MEDIA_TABLET, MEDIA_DESKTOP } from './constants.js';

var UpsellCard = function UpsellCard(_ref) {
  var _ref2;
  var button = _ref.button,
    children = _ref.children,
    className = _ref.className,
    color = _ref.color,
    size = _ref.size,
    id = _ref.id;
  return /*#__PURE__*/React.createElement(Box, {
    id: id,
    "aria-label": button,
    className: className,
    tabIndex: 0,
    sx: (_ref2 = {
      display: 'block',
      position: 'relative',
      fontFamily: '$fonts.sansSerif',
      // Used by heading, and background of button
      '--foreground': {
        blue: '$colors.blue400',
        // Not exact, wanted: #BD7900
        gold: '$colors.yellow500',
        green: '$colors.green500',
        orange: '$colors.orange500',
        purple: '$colors.purple500'
      }[color],
      // Used by hover of button - there is no design for this in figma
      '--foreground-darker': {
        blue: '$colors.blue500',
        gold: '$colors.yellow600',
        green: '$colors.green600',
        orange: '$colors.orange600',
        purple: '$colors.purple600'
      }[color],
      // Used by background of containing box, and text of button
      '--background': {
        blue: '$colors.blue200',
        // Not exact, wanted: #FCEDD1
        gold: '$colors.yellow100',
        green: '$colors.green100',
        // Not exact, wanted: #FFE4DC
        orange: '$colors.orangeRed100',
        purple: '$colors.purple100'
      }[color],
      backgroundColor: 'var(--background)',
      borderRadius: '$radii.xl',
      padding: '$spacing.sm $spacing.md $spacing.md $spacing.md',
      '.Upsell__Button:active:not(:disabled), .Upsell__Button:focus:not(:disabled), .Upsell__Button:hover:not(:disabled)': {
        color: 'var(--background)',
        backgroundColor: 'var(--foreground-darker)',
        borderColor: 'var(--foreground-darker)'
      }
    }, _ref2[MEDIA_TABLET] = {
      padding: ['md', 'lg'].includes(size) ? '$spacing.xxl' : undefined,
      borderRadius: ['md', 'lg'].includes(size) ? '$radii.xxl' : undefined
    }, _ref2[MEDIA_DESKTOP] = {
      padding: size === 'xs' ? '$spacing.xl $spacing.xxl' : undefined
    }, _ref2)
  }, children);
};
UpsellCard.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string.isRequired,
  button: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: ColorPropType.isRequired,
  size: SizePropType.isRequired
} : {};
UpsellCard.defaultProps = {
  className: undefined
};
var UpsellCard$1 = UpsellCard;

export { UpsellCard$1 as default };
